export const FETCH_QUEUE_REQUESTS_RESOLVED = "FETCH_QUEUE_REQUESTS_RESOLVED";
